import type { Application, Document } from '@/types/Activity'

export const isIdEvidenceDocument =
  (application: Application) =>
  (document: Document): boolean =>
    (application?.context?.identity?.idEvidence ?? []).reduce(
      (hasMatchedIdEvidence: boolean, idEvidence: string): boolean => {
        if (!hasMatchedIdEvidence) {
          return document.fileName.includes(idEvidence)
        }

        return hasMatchedIdEvidence
      },
      false,
    )

export const isSelfieDocument = (document: Document): boolean =>
  document.specifiedType === 'selfie'
